<script lang="ts">
  export let variant: "primary" | "secondary" | "warning" | "danger" | "danger-outline" | "ghost" = "primary";
  export let size: "sm" | "md" | "lg" = "md";
  export let type: "button" | "submit" = "button";
  export let disabled = false;
  export let block = false;
  let className = "";
  export { className as class };
</script>

<button
  {type}
  {disabled}
  class="ace-btn {variant} {size} {block ? 'block-btn' : ''} {className}"
  on:click
  {...$$restProps}
>
  <slot />
</button>

<style>
  .ace-btn {
    display: inline-flex;
    min-width: 0;
    max-width: 100%;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    border: 1px solid transparent;
    border-radius: 0.5rem;
    font-weight: 600;
    font-family: inherit;
    cursor: pointer;
    overflow: hidden;
    text-align: center;
    overflow-wrap: normal;
    white-space: normal;
    word-break: normal;
    transition:
      background 0.15s ease,
      border-color 0.15s ease,
      color 0.15s ease,
      box-shadow 0.15s ease,
      transform 0.15s ease;
  }

  .ace-btn:disabled {
    opacity: 0.55;
    cursor: not-allowed;
    transform: none;
  }

  .sm {
    padding: 0.375rem 0.75rem;
    font-size: 0.8125rem;
  }

  .md {
    padding: 0.5rem 1rem;
    font-size: 0.875rem;
  }

  .lg {
    padding: 0.625rem 1.5rem;
    font-size: 0.875rem;
  }

  .block-btn {
    width: 100%;
  }

  .primary {
    background: linear-gradient(180deg, #3468f0, #2554dc);
    color: #ffffff;
    box-shadow: 0 4px 14px rgba(37, 99, 235, 0.3);
  }

  .primary:hover:not(:disabled) {
    background: linear-gradient(180deg, #3f74f2, #2c5ce4);
    box-shadow: 0 6px 18px rgba(37, 99, 235, 0.42);
  }

  .secondary {
    background: #303650;
    border-color: rgba(226, 232, 240, 0.22);
    color: #e8ecf6;
  }

  .secondary:hover:not(:disabled) {
    background: #3b415c;
    color: #ffffff;
  }

  .warning {
    background: var(--ace-warning, #ff7a1a);
    color: var(--ace-warning-contrast, #ffffff);
    box-shadow: 0 4px 14px rgba(249, 115, 22, 0.3);
  }

  .warning:hover:not(:disabled) {
    background: var(--ace-warning-hover, #ff8a2b);
    box-shadow: 0 6px 18px rgba(249, 115, 22, 0.4);
  }

  .danger {
    background: #dc2626;
    color: #ffffff;
  }

  .danger:hover:not(:disabled) {
    background: #ef4444;
  }

  .danger-outline {
    background: rgba(239, 68, 68, 0.08);
    border-color: rgba(239, 68, 68, 0.45);
    color: #fca5a5;
  }

  .danger-outline:hover:not(:disabled) {
    background: rgba(239, 68, 68, 0.18);
    color: #fecaca;
  }

  .ghost {
    background: transparent;
    color: #9aa3b8;
  }

  .ghost:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.06);
    color: #ffffff;
  }
</style>
